import { render, staticRenderFns } from "./AppLoadingScreen.vue?vue&type=template&id=4e70eb90"
import script from "./AppLoadingScreen.vue?vue&type=script&lang=js"
export * from "./AppLoadingScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports